import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapAuthStudioAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.hostedPages?.Brands, currentState.hostedPages?.Brands, {
    trackedEventNames: ["auth_studio_template_created", "auth_studio_template_deployed", "auth_studio_template_edited", "auth_studio_language_changed", "auth_studio_cloned_style"]
  }),
  ...mapStaticMutation(previousState.hostedPages?.CurrentBrand, currentState.hostedPages?.CurrentBrand, {
    trackedEventNames: ["auth_studio_template_created", "auth_studio_template_deployed", "auth_studio_template_edited", "auth_studio_language_changed", "auth_studio_cloned_style"]
  })
];
